<div class="container-fluid dashboard-container">
  <div class="container-form margin-auto margin-bottom-2">
    <!-- Image -->
    <div class="flex-center margin-top-2 text-center position-relative">
      <a routerLink="/teacher/dashboard" routerLinkActive="activated">
        <mat-icon class="margin-right-1 position-absolute fixed-top"
          >arrow_back</mat-icon
        >
        <img class="width-80" src="assets/img/logo.svg" />
      </a>
    </div>

    <div class="col-12 margin-top-1">
      <!-- Photo -->
      <mat-card class="custom-dashboard-mat-card">
        <div class="row justify-content-center">
          <div class="mat-caption col-12 flex-center">
            <div class="flex-center">
              <img class="width-50" src="assets/img/premium-crown.png" />
            </div>
            <div class="mat-h3 font-weight-bold margin-bottom-1">
              {{ "benefit-premium" | translate }}
            </div>
            <div class="mat-h4 text-center">
              {{ "benefit-just-for" | translate }}
              <span class="mat-h2 blue">{{
                price_suscription | currency: "EUR"
              }}</span>
              {{ "benefit-price-per-month" | translate }}
            </div>
            <mat-divider class="margin-top-1"></mat-divider>
            <div class="justify-content-center margin-top-1 w-75 text-center">
              <!-- <h3 class="text-center blue bold">
                {{ "benefit-premium-title-1" | translate }}
              </h3> -->
              <!-- <p>{{ "benefit-premium-subtitle-1" | translate }}</p> -->
              <h3 class="text-center blue bold">
                {{ "benefit-premium-title-2" | translate }}
              </h3>
              <p>{{ "benefit-premium-subtitle-2" | translate }}</p>
              <h3 class="text-center blue bold">
                {{ "benefit-premium-title-3" | translate }}
              </h3>
              <p>{{ "benefit-premium-subtitle-3" | translate }}</p>
              <h3 class="text-center blue bold">
                {{ "benefit-premium-title-4" | translate }}
              </h3>
              <p>{{ "benefit-premium-subtitle-4" | translate }}</p>
            </div>
          </div>

          <div class="d-flex justify-content-center width-100 margin-1">
            <form [formGroup]="form">
              <div class="row p-2 justify-content-center">
                <div class="input-group mb-3" *ngIf="!this.response_cupon">
                  <div class="col-12">
                    <h3><strong>¿Tienes un cupón?</strong></h3>
                  </div>
                  <input
                    type="text"
                    formControlName="couponText"
                    id="coupon_text"
                    class="form-control"
                    placeholder="Introduce el código aquí"
                    aria-label="Introduce el código aquí"
                    aria-describedby="button-addon3"
                  />
                  <button
                    (click)="checkCoupon()"
                    class="btn btn-outline-secondary validate-coupon"
                    type="button"
                    id="button-addon3"
                    style="margin: 0px"
                  >
                    VALIDAR
                  </button>
                </div>
              </div>
              <!-- Pay with -->
              <div class="row">
                <mat-radio-group
                  class="radio-group d-flex flex-column"
                  formControlName="paymentMethod"
                  [color]="'primary'">
                  <mat-radio-button class="radio-button" value="paypal">
                    <img src="assets/img/paypal.png" />
                  </mat-radio-button>
                  <mat-radio-button class="radio-button" value="redsys">
                    <mat-icon class="margin-right-05" svgIcon="card"></mat-icon>
                    {{ "payment-with-card" | translate }}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
              <div class="row mt-3">
                <mat-checkbox
                  class="acept-conditions"
                  formControlName="conditions">He leído y acepto los <a href="#">Términos y Condiciones de contratación</a>
                </mat-checkbox>
              </div>
    
              <div *ngIf="response_cupon" class="width-100">
                <!-- START Cupones tiempo premium -->
                <div
                  *ngIf="response_cupon.coupon.discount_type == 3"
                  class="justify-content-center width-100 text-center border p-2"
                >
                  <span class="success-coupon">CUPÓN APLICADO CORRECTAMENTE</span>
                  <p class="mt-3">
                    <strong>{{ response_cupon.coupon.description }}</strong>
                  </p>
                  <p>
                   Desde hoy cuentas con {{ response_cupon.coupon.value }} días de suscripción premium.
                  </p>
                  <p>Vuelve a iniciar sesión para disfrutar de tu suscripción.</p>
                  <button class="btn btn-success" (click)="goToDasboard()">
                    INICIAR SESIÓN
                  </button>
                </div>
                <!-- END Cupones tiempo premium -->
                <!-- START Cupones descuento importes -->

                <div
                  *ngIf="
                    response_cupon.coupon.discount_type == 0 ||
                    response_cupon.coupon.discount_type == 1
                  "
                >
                  <p>
                    <span class="success-coupon">CUPÓN APLICADO CORRECTAMENTE</span>
                  </p>
                  <span class="mt-3">
                    <strong>{{ response_cupon.coupon.description }}</strong>
                    <p>
                      Paga solo
                      <strong>{{ price_suscription | currency: "EUR" }} €</strong>
                      el primer mes
                    </p>
                  </span>
                </div>
                <!-- END Cupones descuento importes -->
              </div>
              <!-- Pay -->

              <input
                type="hidden"
                value="{{ price_suscription }}"
                formControlName="couponText"
                id="coupon_text"
              />

              <button
                mat-raised-button
                color="primary"
                class="width-50 margin-top-1 margin-bottom-05 padding-05 register-icon"
                [class.spinner]="loading"
                (click)="buyPremium()"
                [disabled]="form.invalid"
              >
                <span>{{ "make-premium" | translate }}</span>
              </button>

            </form>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
